"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var ErrorSubject = /*#__PURE__*/function (_rxjs_1$Subject) {
  _inherits(ErrorSubject, _rxjs_1$Subject);

  var _super = _createSuper(ErrorSubject);

  function ErrorSubject() {
    _classCallCheck(this, ErrorSubject);

    return _super.apply(this, arguments);
  }

  _createClass(ErrorSubject, [{
    key: "error",
    value: function error(err) {
      this.next(err);
    }
  }, {
    key: "wrapAsync",
    value: function wrapAsync(wrapped) {
      this.wrapTAsync(wrapped).catch(function () {
        return null;
      });
    }
  }, {
    key: "wrapTAsync",
    value: function wrapTAsync(wrapped) {
      var _this = this;

      var promise = null;

      switch (typeof wrapped) {
        case "function":
          promise = Promise.resolve(wrapped());
          break;

        default:
          promise = Promise.resolve(wrapped);
      }

      return promise.catch(function (err) {
        _this.next(err);

        return null;
      });
    }
  }]);

  return ErrorSubject;
}(rxjs_1.Subject);

exports.ErrorSubject = ErrorSubject;